import React, { useContext, useMemo } from "react";
import { string, bool, object, func, oneOf } from "prop-types";
import { useTextDomainContext } from "@/app/providers";
import { SelectDropdown } from "./";
import { useStatusArray } from "@/hooks";
import type { StatusOption } from "@/hooks/common/useStatusArray";
import type { DropdownOption } from "@/types";

type StatusDropdownProps = {
  componentLabel?: string;
  defaultValue?: string | StatusOption;
  cacheKey?: string;
  showAll?: boolean;
  required?: boolean;
  sx?: Record<string, unknown>;
  onChange?: (event: StatusOption) => void;
  visualStyle?: "autoComplete" | "autoCompleteMulti" | "simple" | "old";
  refetch?: boolean;
  refetched?: () => void;
};

export const StatusDropdown = (props: StatusDropdownProps) => {
  const { cacheKey, required, sx, refetch, refetched } = props;
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const options = useStatusArray();
  const dropdownOptions = useMemo<DropdownOption[]>(() => {
    return options.map((option) => ({
      value: option.value,
      label: option.label,
      color: option.color,
    }));
  }, [options]);
  // const propsDefault = {
  //   componentLabel: gettext("Status"),
  // };

  //#region useMemo
  const componentLabel = useMemo(() => {
    let label = gettext("Status");
    if (typeof props.componentLabel !== "undefined") {
      label = props.componentLabel;
    }
    return label;
  }, [gettext, props.componentLabel]);

  const defaultValue = useMemo(() => {
    let value = "DK";
    if (typeof props.defaultValue !== "undefined") {
      value =
        typeof props.defaultValue === "string"
          ? props.defaultValue
          : props.defaultValue.value;
    }
    return value;
  }, [props.defaultValue]);
  //#endregion useMemo

  //#region Handlers
  const handleChange = (event: DropdownOption) => {
    if (event.value !== defaultValue) {
      if (typeof props.onChange === "function") {
        props.onChange(event as unknown as StatusOption);
      }
    }
  };
  //#endregion Handlers

  // Use props directly with fallback instead of state
  // const componentLabel = props.componentLabel || propsDefault.componentLabel;

  return (
    <SelectDropdown
      options={dropdownOptions}
      componentLabel={componentLabel}
      defaultValue={defaultValue}
      showAll={props.showAll}
      cacheKey={cacheKey}
      required={required}
      onChange={handleChange}
      refetch={refetch || false}
      refetched={refetched}
      visualStyle="autoComplete"
      sx={{
        ...sx,
      }}
    />
  );

  // return (
  //   <>
  //     {props.visualStyle === "autoComplete" && (
  //       <AutocompleteDropdown
  //         options={options}
  //         componentLabel={componentLabel}
  //         defaultValue={props.defaultValue}
  //         cacheKey={props.cacheKey}
  //         onChange={props.onChange}
  //         showAll={props.showAll}
  //         size="small"
  //         required={props.required}
  //       />
  //     )}
  //
  //     {props.visualStyle === "simple" && (
  //       <SimpleDropdown
  //         options={options}
  //         componentLabel={componentLabel}
  //         defaultValue={props.defaultValue}
  //         onChange={props.onChange}
  //       />
  //     )}
  //
  //     {props.visualStyle === "old" && (
  //       <FabekeDropdown
  //         options={options}
  //         componentLabel={componentLabel}
  //         defaultValue={props.defaultValue}
  //         onChange={props.onChange}
  //       />
  //     )}
  //
  //     {/*<CommonDropdown*/}
  //     {/*  options={options}*/}
  //     {/*  componentLabel={componentLabel}*/}
  //     {/*  showAll={props.showAll}*/}
  //     {/*  defaultValue={props.defaultValue}*/}
  //     {/*  onChange={props.onChange}*/}
  //     {/*/>*/}
  //   </>
  // );
};

StatusDropdown.propTypes = {
  componentLabel: string,
  defaultValue: string,
  cacheKey: string,
  showAll: bool,
  required: bool,
  sx: object,
  onChange: func,
  visualStyle: oneOf(["autoComplete", "autoCompleteMulti", "simple", "old"])
    .isRequired,
  refetch: bool,
  refetched: func,
};
